// import Url from 'url';
import { createActions, asyncAction } from '../helpers/redux';
// import config from '../config';

export const ImportActions = createActions({
  @asyncAction()
  async importFile(module, file, parentId, currentProjectId) {
    return ({ client }) => {
      const data = new FormData();
  
      data.append('module', module);
      data.append('file', file);
      data.append('[EL]parentId', parentId);

      return client.post(`/projects/${currentProjectId}/import`, {
        body: data,
        formData: true,
//        headers: { 'Content-Type': 'multipart/form-data' },
      }).then(response =>  { 
        return {
          response,
        }
      });
    }
  },

});



// WEBPACK FOOTER //
// ./src/actions/import.js